import { Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output } from '@angular/core';
import { ExpandableListItem } from '../models/expandable-list-item.model';
import { MiscUtil } from '../utilities/misc.util';
import { arrayMax } from 'highcharts';

@Component({
  selector: 'expandable-list',
  templateUrl: 'expandable-list.component.html',
  styleUrls: ['expandable-list.component.scss']
})

export class ExpandableListComponent implements OnInit, OnChanges {

  @Input() disableHeader: boolean = false;
  @Input() header: string;

  @Input() body: string;

  @Input() disableFooter: boolean = false;
  @Input() footer: string;

  @Input() dropdownItems: ExpandableListItem[];
  @Input() acceptText: string;
  @Input() columns: string[];
  @Input() rows: ExpandableListItem[];
  @Input() maxRows = -1;
  @Input() includeBlank: boolean = false;
  @Input() defaultToBlank: boolean = false;
  @Output() removeItemCallBack = new EventEmitter();

  @Input() allowDuplicates:boolean = false;
  @Input() readOnly : boolean;
  @Input() skipRowUpdate: boolean = false;

  @Output() rowsChange = new EventEmitter<ExpandableListItem[]>();
  @Output() limitedRowsReached = new EventEmitter();

  @Input() groupArray : string[];
  @Input() type: string = 'expandable-list';

  dynamicHeight: string;
  blankItem: ExpandableListItem = {
    cells: [],
    displayValue: '',
    id: 0
  };
  selectedListItem: ExpandableListItem;
  ngOnChanges(){
    if (MiscUtil.checkArray(this.dropdownItems)){
      this.selectedListItem = this.getDefaultSelection();
  }
}
  ngOnInit(){
       if(this.dropdownItems == null)
      this.dropdownItems = [];

    if(this.rows == null)
      this.rows = [];

    if (this.includeBlank) {
      this.dropdownItems.unshift(this.blankItem);
    }

    this.selectedListItem = this.getDefaultSelection();
  }

  onAdd() {

   if(!this.selectedListItem || this.selectedListItem.id == this.blankItem.id || (!this.allowDuplicates && this.rows.some(item => item.id == this.selectedListItem.id)))
      return;

    if (this.maxRows != -1 && this.rows.length >= this.maxRows) {
      this.limitedRowsReached.emit(true);
      return;
    }
    if(!this.skipRowUpdate){
    this.rows.push(this.selectedListItem);
    this.rowsChange.emit(this.rows);
    }
    this.selectedListItem = this.getDefaultSelection();
    
  }

  onCellChange(cellId: string, rowId: number, control: any) {
    if(!this.skipRowUpdate){
    let cell = this.rows.find(r => r.id == rowId).cells.find(c => c.id == cellId);

    switch (cell.type) {
      case "checkBox": {
        cell.value = control;
        break;
      }
      case "list": {
        cell.value = control;
        this.onJobTypeChange(control,rowId);
        break;
      }
    }
    
    this.rowsChange.emit(this.rows);
    }
    else{
      this.rowsChange.emit(this.rows);
      return;
    }
  }

  private onJobTypeChange(value: any,rowId: number) {
    let Cell=  this.rows.find(r => r.id == rowId).cells.find(c => c.type == "checkBox");
    let _rIndex = this.rows.findIndex(i=>i.id==rowId);

    if (value == "Fixed") {
      Cell.value = false;
      this.rows[_rIndex].groupby = "Fixed"; 
      Cell.readOnly=true;
      }else{
      Cell.readOnly=false;
      this.rows[_rIndex].groupby = "Variable";
      }
     this.refreshOrder(this.rows);
  }

  onRemove(id: number,skipCallBack:boolean) {
    if (this.removeItemCallBack.observers.length > 0 && !skipCallBack) {
      this.removeItemCallBack.emit([this, id]);
    }
    else{
      if (!this.skipRowUpdate) {
        this.limitedRowsReached.emit(false);
        this.rows = this.rows.filter(item => item.id != id);

        this.rows.forEach((element, index) => {
          element.order = index + 1;
        });

        this.rowsChange.emit(this.rows);
      }
    }
  }

  getDefaultSelection(): ExpandableListItem {
    if (this.includeBlank && this.defaultToBlank) {
      return this.blankItem;
    }
    else if (MiscUtil.checkArray(this.dropdownItems)) {
      return this.dropdownItems[0];
    }
  }

  
  refreshOrder(rows: ExpandableListItem[], dragged: boolean = false) {
    if (this.groupArray && !dragged) {
        let counter =0;
        this.groupArray.forEach(n=>{
          rows.forEach((element, index) => {
              if(element.groupby==n){
                counter++;
                element.order = counter;
              }
          });
      });
      rows.sort((a,b)=>{return a.order-b.order;});
    }
    else{
    rows.forEach((element, index) => {
      element.order = index + 1;
    });
  }

  }
}
